import axios from "axios";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { Polish } from "flatpickr/dist/l10n/pl.js";
import $ from "jquery";
import SocialMediaSwitch from "./SocialMediaSwitch";

class PostsFilter {
    constructor() {
        this.loading = document.querySelector(".block-loader");
        this.clearDateBtn = document.querySelector(".archives-tabs__clear-filters");
        this.postFilterTerms = document.querySelectorAll(".jsPostFilter");
        this.postsContainer = document.querySelector("#posts-lists");
        this.postSearcher = document.querySelector(
            ".archives-tabs__search-input"
        );
        this.searchButton = document.querySelector(".searchIconButton")
        this.postSearcherMobile = document.querySelector(
            ".archives-tabs__search-input-mobile"
        );
        this.postSearcherMobileProperInput = document.querySelector(
            ".archives-tabs__search-input--mobile"
        );
        this.selectReal = document.querySelector(".selectCatJs");
        this.morePosts = document.querySelector(".jsMorePosts");
        this.requestState = "";
        this.terms = {
            termId: "",
            search: "",
            day: "",
            month: "",
            year: "",
            postsPerPage: document.documentElement.clientWidth > 1024 ? 18 : 9,
        };

        this.synopticContainer = document.querySelector(".archives-tabs__synoptic");
        this.gotTemplate = null;
        this.gotSynoptic = null;
        this.calendar = null;
        this.paged = 1;
        this.events();
    }

    events() {
        window.addEventListener("resize", (e) => {
            this.terms.postsPerPage =
                document.documentElement.clientWidth > 1024 ? 18 : 9;
        });

        if (document.querySelector(".calendarJs")) {
            window.addEventListener("load", (e) => {
                const calendar = flatpickr(".calendarJs", {
                    locale: Polish,
                    monthSelectorType: "static",
                    onChange: () => {
                        this.requestState = "changing";
                        this.terms.day = calendar.selectedDates[0] ? calendar.selectedDates[0].getDate() : "";
                        this.terms.month = calendar.selectedDates[0] ? calendar.selectedDates[0].getMonth() + 1 : "";
                        this.terms.year = calendar.selectedDates[0] ? calendar.selectedDates[0].getFullYear() : "";
                        this.clearDateBtn.style.display = 'flex'
                        this.clearDateBtn.innerHTML = `<span>` + this.terms.day + "/" + this.terms.month + "/" + this.terms.year + `</span>` +
                            `<svg style='min-width: 1rem' width="32"  height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M25 7L7 25" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M25 25L7 7" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>`
                        this.clearDateBtn.addEventListener("click", (e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            this.clearFilters();
                        })
                        this.paged = 1;
                        this.getPostsByTerms();
                    },

                });

                this.calendar = calendar

            });
        }

        this.postFilterTerms.forEach((term, index) => {
            term.addEventListener("click", (e) => {
                this.requestState = "changing";
                this.terms.termId = e.target.dataset.termid;
                this.paged = 1;
                // this.terms.day = "";
                // this.terms.month = "";
                // this.terms.year = "";
                this.getPostsByTerms();
                this.changeView();
                // location.href = "#posts-lists";
            });
        });
        if (this.postSearcher) {
            this.postSearcherMobile.addEventListener("click", (e) => {
                this.postSearcherMobile.classList.toggle("open");
            });
        }
        if (this.postSearcherMobileProperInput) {
            this.postSearcherMobileProperInput.addEventListener(
                "click",
                (e) => {
                    e.stopPropagation();
                }
            );
        }
        if (this.postSearcherMobileProperInput) {
            this.postSearcherMobileProperInput.addEventListener(
                "change",
                (e) => {
                    e.stopPropagation();
                    this.requestState = "changing";
                    this.terms.search = e.target.value;
                    this.paged = 1;
                    // this.terms.day = "";
                    // this.terms.month = "";
                    // this.terms.year = "";
                    this.getPostsByTerms();
                    this.changeView();
                }
            );
        }
        // if (this.searchButton) {
        //     this.searchButton.addEventListener("click", (e) => {
        //         console.log("changes clicked");
        //         this.requestState = "changing";
        //         this.terms.search = e.target.value;
        //         this.paged = 1;
        //         // this.terms.day = "";
        //         // this.terms.month = "";
        //         // this.terms.year = "";
        //         this.getPostsByTerms();
        //         this.changeView();
        //     })
        // }

        if (this.postSearcher) {
            this.postSearcher.addEventListener("keyup", (e) => {
                this.requestState = "changing";
                this.terms.search = e.target.value;
                this.paged = 1;
                // this.terms.day = "";
                // this.terms.month = "";
                // this.terms.year = "";
                this.getPostsByTerms();
                this.changeView();
            });
        }
        if (this.morePosts) {
            this.morePosts.addEventListener("click", (e) => {
                this.requestState = "top-up";
                this.paged++;
                this.getPostsByTerms();
            });
        }

        $(this.selectReal).on("select2:select", (e) => {

            this.terms.termId = e.params.data.id;
            this.requestState = "changing";
            this.paged = 1;
            this.getPostsByTerms();
        });
    }

    getPostsByTerms() {
        this.loading.style.display = "block";

        if (this.paged === 1) {
            this.morePosts.style.display = "block";
        }
        const data = new FormData();
        data.append("action", "getPostsByTerms");
        data.append("termId", this.terms.termId);
        data.append("search", this.terms.search);
        data.append("paged", this.paged);
        data.append("day", this.terms.day);
        data.append("year", this.terms.year);
        data.append("month", this.terms.month);
        data.append("postsPerPage", this.terms.postsPerPage);

        // for (const pair of data.entries()) {
        //     console.log(pair[0], pair[1]);
        //   }
        //   console.log("url: ", ajax.ajax_url)
        axios
            .post(ajax.ajax_url, data)
            .then((res) => {
                this.gotTemplate = JSON.parse(res.data.data).posts_list;
                this.gotSynoptic = JSON.parse(res.data.data).synoptic;
                // console.log("postsfilter: ", this.gotSynoptic)
                if (this.requestState === "changing") {
                    this.changeView();
                    this.loading.style.display = "none";
                    // eslint-disable-next-line no-unused-vars

                } else {
                    this.addPosts();
                    if (document.querySelector("#no-posts-info")) {
                        this.morePosts.style.display = "none";
                    }
                    this.loading.style.display = "none";
                }

            })
            .catch((err) => {
                this.loading.style.display = "none";
            });


    }

    changeView() {
        this.postsContainer.innerHTML = this.gotTemplate;
        this.synopticContainer.innerHTML = this.gotSynoptic;

    }

    addPosts() {
        if (this.gotTemplate) {
            const loadedPostsContainer = document.createElement("div");
            loadedPostsContainer.innerHTML = this.gotTemplate;
            this.postsContainer.appendChild(loadedPostsContainer);
            const sms = new SocialMediaSwitch();
            sms.getFbAv();
        }
    }

    clearFilters() {
        this.calendar.clear();
        this.clearDateBtn.style.display = "none";
        this.paged = 1;
        this.getPostsByTerms();
    }


}

export default PostsFilter;